<template>
    <div class="h-100 d-flex flex-column">
        <div class="overflow-hidden" :id="timelineContainerId">
            <div :id="timelineId"></div>
        </div>
        <div class="overflow-hidden d-flex">
            <div class="flex-grow-0 flex-shrink-1" :id="tableId"></div>
            <div class="overflow-auto" :id="chartId" @scroll="scrollHeatmap"></div>
        </div>
        <div v-if="!isMxGraphSupported()">
            Charts are not supported by current browser
        </div>
    </div>
</template>

<script lang="ts">
import factory from 'mxgraph';
import {Prop, Component, Vue} from 'vue-facing-decorator';

import $ from 'jquery';

window.mxLoadResources = false;
window.mxLoadStylesheets = false;
window.mxForceIncludes = false;
window.mxResourceExtension = undefined
export const mx = factory.apply(window, [{
  mxBasePath: '',
}]);
// export const mx = factory({
//   mxBasePath: '',
// });
// This makes mxGraph object constructors available globally, which is essential for mxGraph functioning,
// e.g. for decoding graph from XML.
Object.keys(mx).forEach(key => window[key] = mx[key]);

export interface XmlChartDto {
  tableXml: string;
  timelineXml: string;
  chartXml: string;
}

@Component()
export default class MxGraphChart extends Vue {
  @Prop private graphId: string;
  @Prop()
  private initGraph: (graph: typeof mx.mxGraph) => void;
  private table;
  private timeline;
  private chart;

  private get tableId(): string {
    return `${this.graphId}-table`
  }
  private get timelineId(): string {
    return `${this.graphId}-timeline`
  }
  private get timelineContainerId(): string {
    return `${this.graphId}-timeline-container`
  }
  private get chartId(): string {
    return `${this.graphId}-chart`
  }

  public mounted() {
    this.table = new mx.mxGraph(document.getElementById(this.tableId));
    this.chart = new mx.mxGraph(document.getElementById(this.chartId));
    this.timeline = new mx.mxGraph(document.getElementById(this.timelineId));
    this.initGraph(this.table);
    this.initGraph(this.chart);
    this.initGraph(this.timeline);
  }

  public buildChart(chart: XmlChartDto) {
    buildGraph(chart.tableXml, this.table);
    buildGraph(chart.timelineXml, this.timeline)
    buildGraph(chart.chartXml, this.chart);
    this.setSvgDimensions();
  }

  private scrollHeatmap() {
    const jqChart = $(`#${this.chartId}`);
    $(`#${this.tableId}`).css('top', -jqChart.scrollTop());
    $(`#${this.timelineId}`).css('left', -jqChart.scrollLeft());
  }

  private setSvgDimensions() {
    const jqTable = $(`#${this.tableId} > svg`);
    const jqChart = $(`#${this.chartId} > svg`);
    const resourcesWidth = jqTable.css('min-width');
    const timelineHeight = $(`#${this.timelineId} > svg`).css('min-height');
    const chartHeight = jqChart.css('min-height');
    $(`#${this.timelineContainerId}`).css({
      'margin-left': resourcesWidth,
      'min-height': timelineHeight,
      'height': timelineHeight,
    });
    jqChart.css('height', chartHeight);
    jqTable.css('height', chartHeight).css('max-width', resourcesWidth);
  }

  public isMxGraphSupported(): boolean {
    return mx.mxClient.isBrowserSupported();
  }
}

function buildGraph(xml: string, graph: typeof mx.mxGraph) {
  graph.getLabel = function(cell) {
    if (mx.mxUtils.isNode(cell.value)) {
      return cell.getAttribute('text', '');
    }
  };
  const doc = mx.mxUtils.parseXml(xml);
  const codec = new mx.mxCodec(doc);
  codec.decode(doc.documentElement, graph.getModel());
}

</script>
